module.exports = __webpack_public_path__ + "img/app-services-grid-tile.b473ea6d.jpg";